/**
 * Epg list implementation.
 *
 * @author Stoian Roman <stoyan.roman@gmail.com>
 */

'use strict';

/* eslint max-lines-per-function: 0 */

var dom = require('spa-dom'),
    keys = require('stb-keys'),

    Layout     = require('mag-component-layout'),
    LayoutList = require('mag-component-layout-list'),
    metrics    = require('./metrics'),

    fullMonthNames = [
        gettext('January'),
        gettext('February'),
        gettext('March'),
        gettext('April'),
        gettext('May'),
        gettext('June'),
        gettext('July'),
        gettext('August'),
        gettext('September'),
        gettext('October'),
        gettext('November'),
        gettext('December')
    ],
    fullDaysOfWeek = [
        gettext('Sunday '),
        gettext('Monday '),
        gettext('Tuesday '),
        gettext('Wednesday '),
        gettext('Thursday '),
        gettext('Friday '),
        gettext('Saturday ')
    ];


function EpgGrid ( config ) {
    this.scheduleWidth = metrics.scheduleWidth;

    /**
     * Link to the object for limited scopes.
     *
     * @type {DVBList}
     */
    this.time = null;
    this.day = 0;
    this.timeStep = metrics.timeStep;
    this.countOfSteps = metrics.countOfSteps;
    this.scheduleBlock = this.scheduleWidth / this.timeStep;
    this.step = this.timeStep / this.countOfSteps;

    this.timeLineMargin = metrics.timeLineMargin;

    this.itemHeight = metrics.itemHeight;

    this.timeLineTop = metrics.timeLineTop;

    this.$timeBlock = config.$timeBlock;
    this.$programDescription = config.$programDescription;
    this.$programName = config.$programName;
    this.$timeLine = config.$timeLine;

    this.$timeLine.appendChild(dom.tag('div', {className: 'timemark theme-epg-grid-timemark'}));

    this.timers = {};
    this.internal = {};
    // 0- real time 1- in focus
    this.epgMode = 0;
    this.epgFocusTime = null;
    this.epgLastFocused = null;
    if ( !config.events ) {
        config.events = {};
    }
    if ( !config.events.keydown ) {
        config.events.keydown = function ( event ) {
            switch ( event.code ) {
                case keys.right:
                case keys.left:
                    this.moveEpg(event.code);
                    break;
                case keys.up:
                case keys.down:
                case keys.pageUp:
                case keys.pageDown:
                case keys.home:
                case keys.end:
                    // cursor move only on arrow keys
                    this.move(event.code);
                    break;
                case keys.enter:
                    // there are some listeners
                    event.stop = true;
                    this.pressOk();
                    break;
            }
        };
    }
    this.apiProvider = config.apiProvider;

    LayoutList.call(this, config);
}


EpgGrid.prototype = Object.create(LayoutList.prototype);
EpgGrid.prototype.constructor = EpgGrid;


EpgGrid.prototype.renderItem = function ( $item, config ) {
    var self = this,
        layout, domLinks, layoutConfig;

    while ( $item.firstChild ) {
        $item.removeChild($item.firstChild);
    }

    layoutConfig = {
        focusable: false,
        data: config.items
    };

    if ( config.className ) {
        layoutConfig.className = config.className;
    }

    if ( config.events ) {
        layoutConfig.events = config.events;
    } else {
        layoutConfig.events = {
            click: function () {
                self.focusItem($item);
                self.pressOk();
            }
        };
    }

    layout = new Layout(layoutConfig);

    $item.appendChild(layout.$node);
    $item.layout = layout;
    layout.parent = this;
    layout.$parentItem = $item;

    domLinks = config.items[0].value.$node.children;

    $item.censored = config.censored;

    // on init list save needed links
    $item.domLinks = {
        $number: domLinks[0],
        $icon: domLinks[1],
        $title: domLinks[2],
        $archiveIcon: domLinks[3],
        $lockIcon: domLinks[4],
        $archiveLine: domLinks[7]
    };

    if ( config.click ) {
        this.handlers[$item.index] = config.click;
    }
    // item is rendered
    $item.ready = true;
    // }
    $item.value = config.value || {};
    if ( config.value.archive ) {
        config.value.$archiveLine = $item.domLinks.$archiveLine;
        $item.domLinks.$archiveLine.classList.remove('hidden');
    } else {
        config.value.$archiveLine = null;
        $item.domLinks.$archiveLine.classList.add('hidden');
    }
    if ( config ) {
        this.fillItem($item, config);
    }
};


EpgGrid.prototype.setData = function ( config ) {
    LayoutList.prototype.setData.call(this, config);

    if ( this.data.length < this.size ) {
        this.$timeLine.style.height = (this.itemHeight * this.data.length) + this.timeLineTop + 'px';
    } else {
        this.$timeLine.style.height = (this.itemHeight * this.size) + this.timeLineTop + 'px';
    }
};


EpgGrid.prototype.moveEpg = function ( code ) {
    switch ( code ) {
        case keys.left:
            this.subPrev();
            break;
        case keys.right:
            this.subNext();
            break;
    }
};


EpgGrid.prototype.pressOk = function () {
    if ( this.events['click:item'] && this.$focusItem ) {
        // notify listeners
        this.emit('click:item', {$item: this.$focusItem, event: event});
    }
};


/**
 * on Focus event.
 *
 * @param {Object} event - event data
 */
EpgGrid.prototype.onFocus = function ( event ) {
    var self = this,
        focus = 0,
        index, data;

    this.repositionTimeLine();
    if ( this.timers.onFocus ) {
        clearTimeout(this.timers.onFocus);
    }
    if ( this.epgMode ) {
        this.timers.onFocus = setTimeout(function () {
            data = event.$curr.data;
            if ( data.value.epgItems.length ) {
                for ( index = 0; index < data.value.epgItems.length; index++ ) {
                    if ( self.epgFocusTime >= data.value.epgItems[index].data.start && self.epgFocusTime < data.value.epgItems[index].data.end ) {
                        focus = index;
                        break;
                    }
                }
                data.value.epgFocus = focus;
                self.focusEpg(data.value.epgItems[data.value.epgFocus], true);
            } else {
                if ( self.epgLastFocused ) {
                    self.epgLastFocused.classList.remove('theme-epg-grid-focused');
                    self.epgLastFocused.focused = false;
                }
                self.epgLastFocused = null;
            }
        }, core.environment.onFocusDebounceTimeout);

    }
};


EpgGrid.prototype.onOverflow = function () {
    var self = this;

    if ( this.timers.onOverflow ) {
        clearTimeout(this.timers.onOverflow);
    }
    this.timers.onOverflow = setTimeout(function () {
        self.updateEpg();
    }, core.environment.onFocusDebounceTimeout);
};


EpgGrid.prototype.init = function ( config ) {
    LayoutList.prototype.init.call(this, config);

    this.addListener('focus:item', this.onFocus);
    this.addListener('move:view', this.onOverflow);
};


EpgGrid.prototype.startCheck = function () {
    this.checkingTime();
};


EpgGrid.prototype.stopCheck = function () {
    var key;

    for ( key in this.internal ) {
        clearInterval(this.internal[key]);
    }

    for ( key in this.timers ) {
        clearTimeout(this.timers[key]);
    }
};


EpgGrid.prototype.fillItem = function ( $item, config ) {
    var width = 0,
        epgItems = [],
        before = this.time,
        margin = 2,
        $epgItem, index, data;

    dom.clear(config.items[1].value.$node);

    if ( (!$item.censored || core.accessControl.state) && config.value.epgGrid && config.value.epgGrid.length ) {
        for ( index = 0; index < config.value.epgGrid.length; index++ ) {
            data = config.value.epgGrid[index];
            if ( data.start >= this.time + this.timeStep - 60 ) {
                break;
            }

            if ( data.end > this.time ) {
                if ( data.start >= before + 60 ) {
                    $epgItem = dom.tag('div', {className: 'program theme-epg-grid-noData'},
                        dom.tag('div', {className: 'text', data: {focusable: false}}, gettext('No data')));

                    width = (data.start - before) * this.scheduleBlock;
                    width = Math.floor(width) - margin;
                    $epgItem.children[0].style.width = width + 'px';
                    dom.add(config.items[1].value.$node, $epgItem);
                    before = data.start;
                }
                data.focusable = true;

                $epgItem = dom.tag('div', {className: 'program theme-epg-grid-default'},
                    dom.tag('div', {className: 'text', data: data}, data.title));

                if ( data.end < this.time + this.timeStep ) {
                    width = (data.end - before) * this.scheduleBlock;
                } else {
                    width = (this.time + this.timeStep - before) * this.scheduleBlock;
                }
                width = Math.floor(width) - margin;
                before = data.end;
                $epgItem.children[0].style.width = width + 'px';
                $epgItem.data = data;
                dom.add(config.items[1].value.$node, $epgItem);
                epgItems.push($epgItem);
            }
            config.value.epgItems = epgItems;
        }
        if ( before < this.time + this.timeStep ) {
            width = (this.time + this.timeStep - before) * this.scheduleBlock;
            if ( width > 2 * margin ) {
                $epgItem = dom.tag('div', {className: 'program theme-epg-grid-noData'},
                    dom.tag('div', {className: 'text', data: {focusable: false}}, gettext('No data')));
                width = Math.floor( width ) - margin;
                $epgItem.children[0].style.width = width + 'px';
                dom.add(config.items[1].value.$node, $epgItem);
            }
        }
    } else {
        $epgItem = dom.tag('div', {className: 'program theme-epg-grid-noData'},
            dom.tag('div', {className: 'text', data: {focusable: false}}, gettext('No data')));
        $epgItem.children[0].style.width = this.scheduleWidth - margin + 'px';
        dom.add(config.items[1].value.$node, $epgItem);
        config.value.epgItems = [];
    }
};


EpgGrid.prototype.checkCurrent = function () {
    var self = this,
        $item = this.$focusItem,
        time = Date.now() / 1000,
        data, left, check,
        index, child;

    function checkData ( epgItem, focusIndex ) {
        if ( check && epgItem.data && time > epgItem.data.start && time < epgItem.data.end ) {
            epgItem.classList.add('theme-epg-grid-current');
            check = false;
            if ( !self.epgMode && child === $item ) {
                self.focusEpg(epgItem, true);
                $item.data.value.epgFocus = focusIndex;
            }
        } else {
            epgItem.classList.remove('theme-epg-grid-current');
            if ( !self.epgMode && self.$body.children[focusIndex] === $item ) {
                epgItem.classList.remove('theme-epg-grid-focused');
            }
        }
    }

    for ( index = 0; index < this.$body.children.length; index++ ) {
        check = true;
        child = this.$body.children[index];
        if ( child.data && child.data.value.epgItems && child.data.value.epgItems.length ) {
            data = child.data.value.epgItems;
            data.forEach(checkData);
        }
    }

    if ( $item && $item.data.value.$archiveLine ) {
        if ( $item.data.value.epgGrid && $item.data.value.epgGrid.length ) {
            if ( (this.time + this.timeStep) > time ) {
                if ( time >= this.time ) {
                    left = Math.ceil((time - this.time) * this.scheduleBlock);
                    $item.data.value.$archiveLine.style.width = left + 'px';
                    $item.data.value.$archiveLine.style.display = '';
                } else {
                    $item.data.value.$archiveLine.style.display = 'none';
                }
            } else {
                $item.data.value.$archiveLine.style.width = this.scheduleWidth + 'px';
            }
        } else {
            $item.data.value.$archiveLine.style.display = 'none';
        }
    }
};


EpgGrid.prototype.setCurrentProgram = function () {
    if ( this.epgLastFocused && this.epgLastFocused.data ) {
        this.$programDescription.innerText = this.epgLastFocused.data.description || '';
        this.$programName.innerText = this.epgLastFocused.data.title || '';
    } else {
        this.$programDescription.innerText = '';
        this.$programName.innerText = '';
    }
};


EpgGrid.prototype.repositionTimeLine = function () {
    var newTime = new Date(),
        left = 0,
        time = Math.ceil(newTime.getTime() / 1000);

    if ( time >= this.time && this.time + this.timeStep > time ) {
        left = Math.ceil((time - this.time) / this.timeStep * this.scheduleWidth);
        left += this.timeLineMargin;
        this.$timeLine.style.display = 'block';
        this.$timeLine.style.left = left + 'px';
    } else {
        this.$timeLine.style.display = 'none';
    }
    this.checkCurrent();
};


/**
 * Checking EPG in time.
 *
 * @param {boolean} state - epgMode
 */
EpgGrid.prototype.epgModeChange = function ( state ) {
    var self = this;

    this.epgMode = !!state;

    if ( this.timers.epgModeChange ) {
        clearTimeout(this.timers.epgModeChange);
    }

    if ( this.epgMode ) {
        this.timers.epgModeChange = setTimeout(function () {
            self.goToRealTime();
        }, 3 * 60 * 1000);
    }
};


/**
 * Checking EPG in time.
 */
EpgGrid.prototype.checkingTime = function () {
    var newTime = this.getStartTime(),
        self = this;

    if ( this.internal.checkingTime ) {
        clearInterval(this.internal.checkingTime);
    }
    if ( this.epgMode ) {

        return;
    }

    if ( this.time !== newTime ) {
        this.time = newTime;
    }
    this.initTimeBlock();
    // this.repositionTimeLine();
    this.internal.checkingTime = setInterval(function () {
        if ( !self.epgMode  ) {
            newTime = self.getStartTime();
            if ( self.time !== newTime ) {
                self.time = newTime;
                self.initTimeBlock();
            }
        }
        self.repositionTimeLine();
    }, 60 * 1000);
};


EpgGrid.prototype.initTimeBlock = function ( last, first ) {
    var time, dayName, min,
        hour, month, day,
        ms, dateText, index;

    if ( this.time === null ) {
        this.time = this.getStartTime();
    }

    ms = this.time - (this.step / 2);
    time = new Date(ms * 1000);
    dayName = fullDaysOfWeek[time.getDay()];
    min = time.getMinutes();
    hour = time.getHours();
    month = time.getMonth() + 1;
    day = time.getDate();
    dateText = dayName + ', ' + day + ' ' + fullMonthNames[month - 1];

    dom.clear(this.$timeBlock);
    dom.add(this.$timeBlock, dom.tag('div', {className: 'date theme-epg-grid-date'}, dateText));
    for ( index = 2; index <= 2 * this.countOfSteps; index += 2 ) {
        time.setTime((ms + (index * this.step / 2)) * 1000);
        min = time.getMinutes();
        hour = time.getHours();
        dom.add(this.$timeBlock, dom.tag('div', {className: 'hours theme-epg-grid-date ' + (min === 30 ? 'halfhour' : 'hour')},
            (hour < 10 ? '0' + hour : hour) + ':' + (min < 10 ? '0' + min : min),
            dom.tag('div', {className: 'hourmark theme-epg-grid-hourmark'})));
    }
    this.updateEpg(last, first);
};


/**
 * Get start time.
 *
 * @return {number} start time
 */
EpgGrid.prototype.getStartTime = function () {
    var date = new Date(),
        time, delta, sec;

    sec = Math.floor(date.getTime() / 1000);
    time = date.getMinutes() * 60;
    delta = time % (2 * this.step);

    if ( delta < this.step ) {
        return sec - delta - (this.step / 2);
    }

    return  sec - delta + (this.step / 2);
};


EpgGrid.prototype.updateEpg = function ( last, first ) {
    var channelList = [],
        config = {},
        self = this,
        index, childrenLength, dataLength;

    for ( index = 0; index < this.$body.children.length; index++ ) {
        if ( this.$body.children[index].data ) {
            channelList.push(this.$body.children[index].data.value);
        }
    }

    if ( channelList.length === 0 ) {
        return;
    }

    config.channels = channelList;
    if ( !this.time ) {
        this.time = this.getStartTime();
    }
    config.from = this.time * 1000;
    config.to = config.from + (this.timeStep * 1000);
    if ( this.request ) {
        this.request.abort();
    }

    childrenLength = this.$body.children.length;
    dataLength = this.data.length;
    for ( index = 0; index < childrenLength; index++ ) {
        if ( this.$body.children[index].index < dataLength ) {
            dom.clear(this.data[this.$body.children[index].index].items[1].value.$node);
        } else {
            break;
        }
    }

    this.request = this.apiProvider.getChannelsEpg(config, function ( error, data ) {
        if ( !error ) {
            for ( index = 0; index < channelList.length; index++ ) {
                if ( data[channelList[index].id] ) {
                    channelList[index].epgGrid = data[channelList[index].id];
                } else {
                    channelList[index].epgGrid = null;
                }
            }
        }
        for ( index = 0; index < self.$body.children.length; index++ ) {
            if ( self.$body.children[index].data ) {
                self.fillItem(self.$body.children[index], self.data[self.$body.children[index].index]);
            }
        }
        self.checkCurrent();
        if ( self.epgMode ) {
            data = self.$focusItem.data;
            if ( data.value.epgItems.length ) {
                if ( last ) {
                    data.value.epgFocus = data.value.epgItems.length - 1;
                } else if ( first ) {
                    data.value.epgFocus = 0;
                } else {
                    data.value.epgFocus = 0;
                    for ( index = 0; index < data.value.epgItems.length; index++ ) {
                        if ( self.epgFocusTime >= data.value.epgItems[index].data.start && self.epgFocusTime < data.value.epgItems[index].data.end ) {
                            data.value.epgFocus = index;
                            break;
                        }
                    }
                }
                self.focusEpg(data.value.epgItems[data.value.epgFocus], true);
            } else {
                self.focusEpg(self.epgLastFocused, false);
            }
        }
    });
    this.repositionTimeLine();
};


/**
 * Handle focus state for the given item.
 * Also removes the focus from the previously focused item.
 *
 * @param {Node} item - the element to be processed
 * @param {boolean} [state=true] - flag of the state
 */
EpgGrid.prototype.focusEpg = function ( item, state ) {
    state = !!state;

    // valid html element given, enabled and visible
    if ( item.focused !== state ) {
        if ( state ) {
            if ( this.epgLastFocused ) {
                this.epgLastFocused.classList.remove('theme-epg-grid-focused');
                this.epgLastFocused.focused = false;

            }
            item.classList.add('theme-epg-grid-focused');
            item.focused = true;
            this.epgLastFocused = item;
            this.epgFocusTime = item.data.start;
            this.setCurrentProgram();
            // this.repositionTimeLine();
        } else {
            item.classList.remove('theme-epg-grid-focused');
            item.focused = false;
            if ( this.epgLastFocused === item ) {
                this.epgLastFocused = null;
                this.epgFocusTime = this.time;
                this.setCurrentProgram();
                // this.repositionTimeLine();
            }
        }
    }
};


/**
 * Set focus on next sub element.
 */
EpgGrid.prototype.subNext = function () {
    var data = this.$focusItem.data;

    this.epgModeChange(true);
    if ( data.value.epgItems.length && data.value.epgFocus + 1 < data.value.epgItems.length ) {
        data.value.epgFocus++;
        this.focusEpg(data.value.epgItems[data.value.epgFocus], true);
    } else {
        this.time += this.timeStep - this.step;
        this.initTimeBlock(false, true);
    }
};


/**
 * Set focus on prev sub element,
 */
EpgGrid.prototype.subPrev = function () {
    var data = this.$focusItem.data;

    this.epgModeChange(true);
    if ( data.value.epgItems.length > 0 && data.value.epgFocus > 0 ) {
        data.value.epgFocus--;
        this.focusEpg(data.value.epgItems[data.value.epgFocus], true);
    } else {
        this.time -= this.timeStep - this.step;
        this.initTimeBlock(true);
    }
};


/**
 * Go to real time position.
 */
EpgGrid.prototype.goToRealTime = function () {
    var time = this.getStartTime();

    if ( this.epgMode ) {
        this.epgModeChange(false);
        if ( this.time !== time ) {
            this.time = time;
            this.initTimeBlock();
        }
    }
};


module.exports = EpgGrid;
